



<template>
  
<v-layout row wrap>
  <v-flex xs12>
    
       <v-toolbar
      color="white"
      style="width:100%"
      floating
      dense
      class=" mr-0 ml-0 mb-3" elevation-1
    >
      
          <v-icon>location_on</v-icon>
        <gmap-autocomplete 
        @place_changed="setPlace" v-model="place.formatted_address" style="width:100%;">
        </gmap-autocomplete>
    
    </v-toolbar>
  


    <Gmap-Map style="width: 100%; height: 300px;" :zoom="18" :center="center"  ref="map">
      <Gmap-Marker
        :position="marker.position"
        :clickable="true" 
        :draggable="true"
        @click="center = marker.position"
        @position_changed="updateChild(marker, 'position', $event)"
        @dragend="getLocation"
        >
           <gmap-info-window  :opened="opened">{{ifw}}</gmap-info-window>
        
        </Gmap-Marker>
             <div slot="visible">
        <div style="bottom: 0; left: 0; background-color: #0000FF; color: white; position: absolute; z-index: 100">
          {{statusText}}
        </div>
      </div>
    </Gmap-Map>
</v-flex>
  </v-layout>
 

</template>

<script>
export default {
  props: ["place", "center", "marker", "new"],
  data() {
    return {
      statusText: null,
      opened: false
    };
  },
  methods: {
    updateChild(object, field, event) {
      if (field === "position") {
        object.position = {
          lat: event.lat(),
          lng: event.lng()
        };
        this.opened = true;
      }
    },
    setPlace(place) {
      this.$emit("newLocation", place);
      this.marker.ifw = place.formatted_address;
      this.usePlace(place);
      this.opened = true;
    },
    usePlace(place) {
      this.$emit("newLocation", place);
      this.$emit("newMarker", {
        position: {
          lat: parseFloat(place.geometry.location.lat()),
          lng: parseFloat(place.geometry.location.lng())
        }
      });
      this.center.lat = parseFloat(place.geometry.location.lat());
      this.center.lng = parseFloat(place.geometry.location.lng());
    },
    getLocation() {
      var scope = this;
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        {
          location: {
            lat: parseFloat(this.marker.position.lat),
            lng: parseFloat(this.marker.position.lng)
          }
        },
        function(results, status) {
          if (status === "OK") {
            if (results[0]) {
              scope.marker.ifw = results[0].formatted_address;
              scope.$emit("newLocation", results[0]);
              this.opened = true;
            } else {
              console.log("No results found");
            }
          }
        }
      );
    }
  },
  update() {
    this.$refs.map.resize();
  },
  computed: {
    ifw() {
      return this.place.formatted_address;
    }
  },
  mounted() {
    if (navigator.geolocation && this.new == true) {
      navigator.geolocation.getCurrentPosition(
        function(position) {
          let pos = {
            lat: parseFloat(position.coords.latitude),
            lng: parseFloat(position.coords.longitude)
          };
          this.center.lat = parseFloat(pos.lat);
          this.center.lng = parseFloat(pos.lng);
          this.marker.position.lat = parseFloat(pos.lat);
          this.marker.position.lng = parseFloat(pos.lng);
          this.getLocation();
          this.new = false;
        }.bind(this)
      );
    } else {
      
    }
  }
};
</script>


<style>
.toolbar__content {
  width: -webkit-fill-available !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/PickLocation.vue